import React from 'react';
import { CalenderDeadlineIcon, SubscriptionL1Icon } from '@fiverr-private/visuals';
import { Gql } from '@fiverr-private/dynamic_matching';

export const COPIES_PREFIX = 'sections.need_type';

export const needTypeOptions: Record<Gql.DmBriefNeedType, any> = {
  [Gql.DmBriefNeedType.Ongoing]: {
    title: `${COPIES_PREFIX}.ongoing.title` as const,
    subtitle: `${COPIES_PREFIX}.ongoing.subtitle` as const,
    icon: <SubscriptionL1Icon />,
  },
  [Gql.DmBriefNeedType.OneTime]: {
    title: `${COPIES_PREFIX}.one_time.title` as const,
    subtitle: `${COPIES_PREFIX}.one_time.subtitle` as const,
    icon: <CalenderDeadlineIcon size="lg" />,
  },
};

export const ADDITIONAL_WORK_CHECKBOX_ID = 'additional-work-checkbox';
